import * as Yup from "yup";
import yupLocale from "kmc/validations/yupLocale";
import * as Forms from './forms';

Yup.setLocale(yupLocale);

const Vue = require('vue');

window.Vue = Vue;
window.kmc = {};
window.kmc.forms = Forms;

